import { Lumberjack } from "@shopfront/lumberjack";
import { IndexedDBBackend } from "@shopfront/lumberjack/lib/Backends/IndexedDBBackend";
import UUID from "../Utilities/Generic/UUID";

export const lumberjackBackend = new IndexedDBBackend({
    maxNumberOfLogs: 200000,
});

export const lumberjack = new Lumberjack(lumberjackBackend, {
    applicationName: "Shopfront",
    timestamp      : true,
    trace          : false,
    contextId      : UUID.generate(),
});
